/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useEffect } from "react";
import { View } from "react-native";
import Highlighter from "react-highlight-words";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import { Text, ProfileImage } from "UpduoLibrary";
import { formattedTimeString } from "../config/Utilities";
import { UserType } from "graphql/internal/generated";

interface TranscriptionBlockProps {
  name?: string;
  user?: UserType;
  timestamp: number;
  text: string;
}

export default function TranscriptionBlock({
  name,
  user,
  timestamp,
  text,
}: TranscriptionBlockProps) {
  const transcriptionKeyword = useSelector(
    (state: RootState) => state.transcriptionKeyword
  );

  useEffect(() => {
    if (transcriptionKeyword) {
      document
        ?.getElementsByClassName("transcriptionHits")
        ?.item(0)
        ?.scrollIntoView();
    }
  }, [transcriptionKeyword]);

  return (
    <View style={{ marginBottom: 16 }}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginBottom: 8,
        }}
      >
        <ProfileImage userObject={user} size={25} />
        <Text
          style={{
            color: "#333333",
            fontWeight: "bold",
            marginLeft: 8,
            marginRight: 12,
            fontSize: 14,
            lineHeight: 19,
          }}
        >
          {name ? name : "Speaker"}
        </Text>
        <Text
          style={{
            color: "#828282",
            fontSize: 14,
            lineHeight: 19,
          }}
        >
          {formattedTimeString(timestamp)}
        </Text>
      </View>
      <View style={{ marginHorizontal: 33 }}>
        <Text style={{ fontSize: 14, lineHeight: 19 }}>
          {transcriptionKeyword ? (
            <Highlighter
              highlightClassName={"transcriptionHits"}
              searchWords={[transcriptionKeyword]}
              autoEscape={true}
              textToHighlight={text}
            />
          ) : (
            text
          )}
        </Text>
      </View>
    </View>
  );
}
